import { FC, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { selectCurrentTeam, selectCurrentTeamInvoicePermissions } from 'containers/app/appSlice';
import BuyersPreview from 'containers/invoices/buyers-preview/BuyersPreview';
import CreateInvoice from 'containers/invoices/create-invoice/CreateInvoice';
import { useLazyGetTeamProfileDataDataQuery } from 'containers/team-profile/api';

import { useAppSelector } from 'hooks';
import routesPath from 'routes/RoutesPath';

enum CreatePageState {
  CREATE = 'CREATE_INVOICE',
  PREVIEW = 'INVOICE_PREVIEW'
}

const CreateInvoicePage: FC = () => {
  const invoicePermissions = useAppSelector(selectCurrentTeamInvoicePermissions);

  const [createPageState, setCreatePageState] = useState<CreatePageState>(CreatePageState.CREATE);

  const currentTeam = useAppSelector(selectCurrentTeam);

  const handlePreviewClick = () => {
    setCreatePageState(CreatePageState.PREVIEW);
  };

  const handleClose = () => {
    setCreatePageState(CreatePageState.CREATE);
  };

  const [getTeamProfileDataDataQuery, getTeamProfileDataDataQueryState] = useLazyGetTeamProfileDataDataQuery();

  useEffect(() => {
    if (currentTeam?.id) {
      getTeamProfileDataDataQuery({ teamId: currentTeam?.id.toString() });
    }
  }, [currentTeam]);

  const { data: getTeamProfileData } = getTeamProfileDataDataQueryState;

  return invoicePermissions.createInvoice ? (
    <>
      {createPageState === CreatePageState.CREATE && <CreateInvoice onPreviewClick={handlePreviewClick} />}
      {createPageState === CreatePageState.PREVIEW && (
        <BuyersPreview getTeamProfileData={getTeamProfileData} goBack={handleClose} />
      )}
    </>
  ) : (
    <Navigate to={routesPath.HOME} replace />
  );
};

export default CreateInvoicePage;
